// ABOUTME: Card component with Precision Sharp design system.
// ABOUTME: Supports hover effects and click interactions.

import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'glass' | 'surface' | 'outline';
  interactive?: boolean;
  header?: ReactNode;
  footer?: ReactNode;
  /** Allow content to overflow (e.g., for dropdowns). Default: false */
  overflowVisible?: boolean;
}

const variantClasses = {
  glass: 'card',
  surface: 'card-flat',
  outline: 'card-outlined',
};

export const Card = forwardRef<HTMLDivElement, CardProps>(
  (
    {
      variant = 'glass',
      interactive = false,
      header,
      footer,
      children,
      className = '',
      overflowVisible = false,
      ...props
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={`
          ${overflowVisible ? 'overflow-visible' : 'overflow-hidden'}
          ${interactive ? 'card-interactive' : variantClasses[variant]}
          ${className}
        `}
        {...props}
      >
        {header && (
          <div className="px-4 py-3 border-b border-surface-200">
            {header}
          </div>
        )}
        <div className="p-5">{children}</div>
        {footer && (
          <div className="px-4 py-3 border-t border-surface-200">
            {footer}
          </div>
        )}
      </div>
    );
  }
);

Card.displayName = 'Card';
